// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a475f016","596":"331cb96f","784":"87f1e57c"}[chunkId] + ".chunk.js";
};